import { workScheduleColor } from '@medical/styles'
import { formatExtendedTime } from './extendedTimeUtils'

const workScheduleToEvents = workSchedules =>
  workSchedules.map(workSchedule => {
    const {
      id,
      startTime: start,
      endTime: end,
      accepted,
      clinicalDepartment: {
        name: clinicalDepartmentName,
        clinic: { name: clinicName },
      },
    } = workSchedule
    const title = `${formatExtendedTime(start, start)} - ${formatExtendedTime(
      start,
      end
    )} \n${clinicName}${clinicalDepartmentName}`
    // const title = `${clinicName} ${clinicalDepartmentName}`
    const color = workScheduleColor[accepted]
    return {
      id,
      start,
      end,
      color,
      title,
    }
  })

export default workScheduleToEvents
